import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '@/views/DashboardView.vue'
import { getAccessToken } from '@/api/auth'
import { useAuthStore } from '@/stores/auth'
import { useToastStore } from '@/stores/toast'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      // public = ไม่ต้อง login + ใช้ layout เปล่า (ไม่มี sidebar) ดู App.vue
      meta: { public: true },
    },
    {
      path: '/',
      name: 'dashboard',
      component: DashboardView,
    },
    {
      path: '/maps',
      name: 'maps',
      component: () => import('@/views/MapsView.vue'),
    },
    {
      path: '/station/:id',
      name: 'station-detail',
      component: () => import('@/views/StationDetailView.vue'),
    },
    {
      path: '/history',
      name: 'history',
      component: () => import('@/views/HistoryView.vue'),
    },
    {
      path: '/alarms',
      name: 'alarms',
      component: () => import('@/views/AlarmView.vue'),
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/views/NotificationView.vue'),
    },
    {
      path: '/settings/stations',
      name: 'settings-stations',
      component: () => import('@/views/settings/StationsListView.vue'),
      meta: { permission: 'MANAGE_MASTER' },
    },
    {
      path: '/settings/stations/new',
      name: 'station-new',
      component: () => import('@/views/settings/StationFormView.vue'),
      meta: { permission: 'MANAGE_MASTER' },
    },
    {
      path: '/settings/stations/:id/edit',
      name: 'station-edit',
      component: () => import('@/views/settings/StationFormView.vue'),
      meta: { permission: 'MANAGE_MASTER' },
    },
    {
      path: '/settings/thresholds',
      name: 'settings-thresholds',
      component: () => import('@/views/settings/ThresholdsView.vue'),
    },
  ],
})

// Navigation guard: บังคับ login ทุก route ยกเว้นที่ meta.public และเช็ค
// meta.permission (ระดับ route) ไม่ใช่แค่ซ่อนเมนู — กันพิมพ์ URL ตรงๆ
router.beforeEach(async (to) => {
  const isLoggedIn = !!getAccessToken()

  if (to.meta.public) {
    // ถ้า login แล้วยังจะเข้า /login ให้เด้งกลับ dashboard
    if (to.name === 'login' && isLoggedIn) return { name: 'dashboard' }
    return true
  }

  if (!isLoggedIn) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  const required = to.meta.permission as string | undefined
  if (required) {
    const auth = useAuthStore()
    // ต้องมั่นใจว่าโหลด role/permission มาแล้วก่อนตัดสิน (เช่นตอน refresh หน้า
    // ตรงเข้า URL ที่ต้องมีสิทธิ์ — guard อาจวิ่งก่อน profile โหลดเสร็จ)
    if (!auth.user) await auth.loadProfile()
    if (!auth.hasPermission(required)) {
      useToastStore().error('คุณไม่มีสิทธิ์เข้าถึงหน้านี้')
      return { name: 'dashboard' }
    }
  }
  return true
})

export default router
